import React, { useState, useEffect } from "react";
import { Menu } from "antd";
import {
  SnippetsOutlined,
  DesktopOutlined,
  AppstoreOutlined,
  SettingOutlined,
  UserOutlined,
  TeamOutlined,
  FileOutlined,
  UserAddOutlined,
  ClusterOutlined,
  ScheduleOutlined,
  BookOutlined,
  IdcardOutlined,
  ControlOutlined,
  LogoutOutlined,
  WalletOutlined,
  BlockOutlined,
  SafetyOutlined,
  CreditCardOutlined,
  MessageOutlined,
  MailOutlined,
  LockOutlined,
  ApartmentOutlined,
  HomeOutlined,
  FileTextOutlined,
  CalendarOutlined,
  ShoppingOutlined,
  TagOutlined,
  ToolOutlined,
  CustomerServiceOutlined,
  ClockCircleOutlined,
  SkinOutlined,
  CheckCircleOutlined,
  TrademarkCircleOutlined,
  DollarCircleOutlined,
  HeartOutlined,
  ColumnWidthOutlined,
  StarOutlined,
  SmileOutlined,
  ContactsOutlined,
  UsergroupAddOutlined,
  CarryOutOutlined,
  SecurityScanOutlined,
  CheckSquareOutlined,
  FormOutlined,
  WhatsAppOutlined,
  UnorderedListOutlined,
  GlobalOutlined,
  ReadOutlined,
  AccountBookOutlined,
  DollarOutlined,
  SolutionOutlined,
  DeploymentUnitOutlined,
  RadiusUpleftOutlined,
  BankOutlined,
  UserSwitchOutlined,
  // CreditCardOutlined,
} from "@ant-design/icons";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Module } from "../../types/Module";
import { buildMenuTree } from "./menuUtils";
import { customThemes } from '../../themeConfig';
import { logout } from '../../redux/slice/userSlice';
import { apiRequest } from '../../service/apiRequest';

import { useDispatch, useSelector } from 'react-redux';




type Props = {
  modules: Module[];
  selectedKey: string;
  openKeys: string[];
  darkMode: boolean;
  themeStyles: {
    headerBg: string;
    siderBg: string;
    textColor: string;
    footerBg: string;
  };
  siderRef: React.RefObject<HTMLDivElement | null>;
};
const iconMap: Record<string, React.ReactElement> = {
  dashboard: <DesktopOutlined />,
  tickets: <SnippetsOutlined />,
  usermaster: <UserOutlined />,
  frontdesk: <UserOutlined />,
  user: <UserAddOutlined />,
  master: <AppstoreOutlined />,
  student: <SmileOutlined />,
  team: <TeamOutlined />,
  file: <FileOutlined />,
  setting: <SettingOutlined />,
  category: <ClusterOutlined />,
  class: <ScheduleOutlined />,
  subject: <BookOutlined />,
  lead: <ContactsOutlined />,
  module: <BlockOutlined />,
  modulemaster: <ControlOutlined />,
  logout: <LogoutOutlined />,
  feesstructure: <WalletOutlined />,
  permission: <SafetyOutlined />,
  paymentsetting: <CreditCardOutlined />,
  smssetting: <MessageOutlined />,
  emailsetting: <MailOutlined />,
  changepassword: <LockOutlined />,
  organizationmaster: <ApartmentOutlined />,
  organization: <HomeOutlined />,
  exams: <FileTextOutlined />,
  timetable: <CalendarOutlined />,
  productmaster: <ShoppingOutlined />,
  products: <TagOutlined />,
  servicemaster: <ToolOutlined />,
  services: <CustomerServiceOutlined />,
  sessionmaster: <ClockCircleOutlined />,
  templatemaster: <FileTextOutlined />,
  fabrictype: <SkinOutlined />,
  qualitynames: <CheckCircleOutlined />,
  brandnames: <TrademarkCircleOutlined />,
  saletypes: <DollarCircleOutlined />,
  productuse: <ToolOutlined />,
  caring: <HeartOutlined />,
  sizes: <ColumnWidthOutlined />,
  productgrade: <StarOutlined />,
  studentleads: <UsergroupAddOutlined />,
  attendancemaster: <FormOutlined />,
  attendance: <CheckSquareOutlined />,
  gatepass: <SecurityScanOutlined />,
  holidays: <CarryOutOutlined />,
  whatsapp: <WhatsAppOutlined />,
  result: <UnorderedListOutlined />,
  webmaster: <GlobalOutlined />,
  booknumber: <ReadOutlined />,
  billing: <AccountBookOutlined />,
  voucher: <DollarOutlined />,
  clientmaster: <SolutionOutlined />,
  studentmaster: <UserOutlined />,
  tailormaster: <DeploymentUnitOutlined />,
  threedmaster: <RadiusUpleftOutlined />,
  vouchers: <BankOutlined />,
  voucher2: <BankOutlined />,
  accounts: <UserSwitchOutlined />

};

const getIcon = (iconName: string): React.ReactElement | null => {
  return iconMap[iconName.toLowerCase()] ?? null;
};

// const buildMenuItems = (modules: Module[]): any[] =>
//   modules.map((mod) => {
//     const icon = getIcon(mod.module_icon || mod.module_name);
//     // console.log("icon", icon)
//     if (mod.children && mod.children.length > 0) {
//       return {
//         key: String(mod.module_id),
//         icon,
//         label: mod.module_name,
//         children: buildMenuItems(mod.children), // recursion
//       };
//     }

//     return {
//       key: String(mod.module_id),
//       icon,
//       label: <Link to={mod.module_url}>{mod.module_name}</Link>,
//     };
//   });


const buildMenuItems = (modules: Module[], onLogout?: () => void): any[] =>
  modules.map((mod) => {
    const icon = getIcon(mod.module_icon || mod.module_name);
    const normalizedName = (mod.module_name || '').toLowerCase().trim();

    if (mod.children && mod.children.length > 0) {
      return {
        key: String(mod.module_id),
        icon,
        label: mod.module_name,
        children: buildMenuItems(mod.children, onLogout),
      };
    }

    // 🛑 Special case for Logout
    if (normalizedName === 'logout') {
      return {
        key: 'logout',
        icon,
        label: 'Logout',
        onClick: onLogout,
      };
    }

    return {
      key: String(mod.module_id),
      icon,
      label: <Link to={mod.module_url}>{mod.module_name}</Link>,
    };
  });



const SidebarMenu: React.FC<Props> = ({ modules, selectedKey, openKeys, darkMode, siderRef, }) => {
  const { pathname } = useLocation();
  const [activeKey, setActiveKey] = useState<string>(selectedKey);
  const [openKeysState, setOpenKeysState] = useState<string[]>(openKeys);
  const themeStyles = darkMode ? customThemes.dark : customThemes.light;
  const [siderWidth, setSiderWidth] = useState(240);


  // Redux hooks
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state: any) => state.user?.user); // Adjust the type accordingly


  useEffect(() => {
    const findActiveKey = (modules: Module[], currentPath: string): string | null => {
      for (const module of modules) {
        if (module.module_url === currentPath) {
          return String(module.module_id);
        }
        if (module.children) {
          const found = findActiveKey(module.children, currentPath);
          if (found) return found;
        }
      }
      return null;
    };

    const activeModuleKey = findActiveKey(modules, pathname);
    if (activeModuleKey) {
      setActiveKey(activeModuleKey);
    }
  }, [pathname, modules]);

  useEffect(() => {
    const findOpenKeys = (modules: Module[], currentPath: string): string[] => {
      const openKeysArray: string[] = [];

      for (const module of modules) {
        if (
          module.module_url === currentPath ||
          (module.children && module.children.some((child) => child.module_url === currentPath))
        ) {
          openKeysArray.push(String(module.module_id));
        }

        if (module.children) {
          openKeysArray.push(...findOpenKeys(module.children, currentPath));
        }
      }

      return openKeysArray;
    };

    const newOpenKeys = findOpenKeys(modules, pathname);
    setOpenKeysState(newOpenKeys);
  }, [pathname, modules]);

  const treeData = buildMenuTree(modules);
  const menuItems = buildMenuItems(treeData);

  const onOpenChange = (keys: string[]) => {
    setOpenKeysState(keys);
  };



  useEffect(() => {
    const styleId = 'custom-theme-sidebar-style';
    let styleTag = document.getElementById(styleId) as HTMLStyleElement | null;

    if (!styleTag) {
      styleTag = document.createElement('style');
      styleTag.id = styleId;
      document.head.appendChild(styleTag);
    }

    const selectedBg = themeStyles.headerBg; // For selected menu item background
    const hoverBg = `${selectedBg}33`; // 20% opacity
    const activeBg = `${selectedBg}55`; // 33% opacity
    const dropdownBg = themeStyles.siderBg; // Your desired submenu popup background color
    // const textColor = themeStyles.textColor;
    const textColor = themeStyles.contentText || '#fff';

    styleTag.innerHTML = `
    /* Selected item background and text color */
    .ant-menu-item-selected,
    .ant-menu-submenu-selected {
      background-color: ${selectedBg} !important;
      color: ${textColor} !important;
    }
    .ant-menu-item-selected a {
      color: ${textColor} !important;
    }

    /* Hover */
    .ant-menu-item:hover,
    .ant-menu-submenu-title:hover {
      background-color: ${hoverBg} !important;
    }

    /* Active (clicked) */
    .ant-menu-submenu-title:active {
      background-color: ${activeBg} !important;
    }

    /* Dropdown (submenu popup) background */
    .ant-menu-submenu-popup {
      background-color: ${dropdownBg} !important;
      color: ${textColor} !important;
      box-shadow: 0 3px 8px rgba(0,0,0,0.15);
    }

    /* Also target submenu popup in light and dark mode */
    .ant-menu-submenu-popup.ant-menu-light {
      background-color: ${dropdownBg} !important;
      color: ${textColor} !important;
    }

    .ant-menu-submenu-popup.ant-menu-dark {
      background-color: ${dropdownBg} !important;
      color: ${textColor} !important;
    }

    .ant-menu-submenu-popup .ant-menu-item,
    .ant-menu-submenu-popup .ant-menu-submenu-title {
      color: ${textColor} !important;
    }

    .ant-menu-submenu-popup .ant-menu-item:hover {
      background-color: ${hoverBg} !important;
    }
  `;
  }, [themeStyles]);


  useEffect(() => {
    const styleId = 'custom-theme-sidebar-style';
    let styleTag = document.getElementById(styleId) as HTMLStyleElement | null;

    if (!styleTag) {
      styleTag = document.createElement('style');
      styleTag.id = styleId;
      document.head.appendChild(styleTag);
    }

    const selectedBg = themeStyles.headerBg;
    const hoverBg = `${selectedBg}33`;
    const activeBg = `${selectedBg}55`;
    const dropdownBg = themeStyles.siderBg;
    const textColor = themeStyles.textColor || '#fff';

    styleTag.innerHTML = `
    /* Selected item background and text color */
    .ant-menu-item-selected,
    .ant-menu-submenu-selected {
      background-color: ${selectedBg} !important;
      color: ${textColor} !important;
    }
    .ant-menu-item-selected a,
    .ant-menu-item a,
    .ant-menu-submenu-title,
    .ant-menu-item,
    .ant-menu-submenu-title > span,
    .ant-menu-submenu-title a {
      color: ${textColor} !important;
    }

    /* Hover */
    .ant-menu-item:hover,
    .ant-menu-submenu-title:hover {
      background-color: ${hoverBg} !important;
      color: ${textColor} !important;
    }
    .ant-menu-item:hover a {
      color: ${textColor} !important;
    }

    /* Active (clicked) */
    .ant-menu-submenu-title:active {
      background-color: ${activeBg} !important;
    }

    /* Dropdown (submenu popup) background */
    .ant-menu-submenu-popup {
      background-color: ${dropdownBg} !important;
      color: ${textColor} !important;
      box-shadow: 0 3px 8px rgba(0,0,0,0.15);
    }

    /* Also target submenu popup in light and dark mode */
    .ant-menu-submenu-popup.ant-menu-light,
    .ant-menu-submenu-popup.ant-menu-dark {
      background-color: ${dropdownBg} !important;
      color: ${textColor} !important;
    }

    .ant-menu-submenu-popup .ant-menu-item,
    .ant-menu-submenu-popup .ant-menu-submenu-title {
      color: ${textColor} !important;
    }

    .ant-menu-submenu-popup .ant-menu-item:hover {
      background-color: ${hoverBg} !important;
    }
  `;
  }, [themeStyles]);



  // Logout function
  const useLogout = () => {
    const handleLogout = async () => {
      try {
        if (user) {
          await apiRequest({
            method: 'get',
            url: `admin-logout`,
          });
        }
      } catch (error) {
        console.error('Logout failed:', error);
      } finally {
        dispatch(logout());
        navigate('/login', { replace: true });
      }
    };
    return handleLogout;
  };

  const handleLogout = useLogout();

  //  Split modules
  const bottomModules = ["logout"]; // Only logout at the bottom
  const normalize = (name: string = "") => name.trim().toLowerCase();

  const topModules = treeData.filter(
    (mod) => !bottomModules.includes(normalize(mod.module_name))
  );
  const footerModules = treeData.filter((mod) =>
    bottomModules.includes(normalize(mod.module_name))
  );

  const topMenuItems = buildMenuItems(topModules, handleLogout);
  const footerMenuItems = buildMenuItems(footerModules, handleLogout);


  useEffect(() => {
    const styleId = 'custom-theme-sidebar-style';
    let styleTag = document.getElementById(styleId) as HTMLStyleElement | null;

    if (!styleTag) {
      styleTag = document.createElement('style');
      styleTag.id = styleId;
      document.head.appendChild(styleTag);
    }

    const selectedBg = themeStyles.headerBg;
    const hoverBg = `${themeStyles.siderBg}cc`; // 80% opacity
    const activeBg = `${themeStyles.siderBg}aa`; // 66% opacity
    const dropdownBg = themeStyles.siderBg;
    const textColor = themeStyles.textColor || '#fff';

    styleTag.innerHTML = `
    /* Selected item background and text color */
    .ant-layout-sider {
      background-color: ${dropdownBg} !important;
    }

    /* Make menu background consistent */
    .ant-menu,
    .ant-menu-root,
    .ant-menu-inline,
    .ant-menu-vertical {
      background-color: ${dropdownBg} !important;
    }
    .ant-menu-item-selected,
    .ant-menu-submenu-selected {
      background-color: ${selectedBg} !important;
      color: ${textColor} !important;
    }

    .ant-menu-item-selected a,
    .ant-menu-item a,
    .ant-menu-submenu-title,
    .ant-menu-item,
    .ant-menu-submenu-title > span,
    .ant-menu-submenu-title a {
      color: ${textColor} !important;
    }

    /* Hover */
    .ant-menu-item:hover,
    .ant-menu-submenu-title:hover {
      background-color: ${hoverBg} !important;
      color: ${textColor} !important;
    }

    .ant-menu-item:hover a {
      color: ${textColor} !important;
    }

    /* Active (clicked) */
    .ant-menu-submenu-title:active {
      background-color: ${activeBg} !important;
    }

    /* Dropdown (submenu popup) background */
    .ant-menu-submenu-popup {
      background-color: ${dropdownBg} !important;
      color: ${textColor} !important;
      box-shadow: 0 3px 8px rgba(0,0,0,0.15);
    }

    .ant-menu-submenu-popup.ant-menu-light,
    .ant-menu-submenu-popup.ant-menu-dark {
      background-color: ${dropdownBg} !important;
      color: ${textColor} !important;
    }

    .ant-menu-submenu-popup .ant-menu-item,
    .ant-menu-submenu-popup .ant-menu-submenu-title {
      color: ${textColor} !important;
    }

    .ant-menu-submenu-popup .ant-menu-item:hover {
      background-color: ${hoverBg} !important;
    }

    /* Collapsed sidebar menu item hover */
    .ant-menu-inline-collapsed .ant-menu-item:hover,
    .ant-menu-inline-collapsed .ant-menu-submenu-title:hover {
      background-color: ${hoverBg} !important;
      color: ${textColor} !important;
    }

    /* Collapsed icon-only hover text color */
    .ant-menu-inline-collapsed .ant-menu-item:hover span,
    .ant-menu-inline-collapsed .ant-menu-submenu-title:hover span {
      color: ${textColor} !important;
    }
    .ant-menu {
      padding-left: 0 !important;
      margin-left: 0 !important;
    }

  

    /* Optional: Make sure the popup doesn't get cut off by layout overflow */
    .ant-layout-sider,
    .ant-menu {
      overflow: visible !important;
    }

    /* Fix sidebar collapsed submenu hover overflow */
    .ant-menu-inline-collapsed .ant-menu-submenu-popup {
      left: 100% !important;
      top: auto !important;
      transform: none !important;
    }


  /* Optional: limit submenu item height for consistency */
  .ant-menu-submenu-popup .ant-menu-item {
    min-height: 40px; /* Adjust based on your item design */
  }

    // custom scrollbar
    /* Custom slim scrollbar for submenu popups and sidebar */
    .ant-menu-submenu-popup,
    .ant-layout-sider,
    .ant-menu {
      scrollbar-width: thin;
      scrollbar-color: ${textColor} ${dropdownBg}; /* Firefox */
    }

    .ant-menu-submenu-popup::-webkit-scrollbar,
    .ant-layout-sider::-webkit-scrollbar,
    .ant-menu::-webkit-scrollbar {
      width: 6px;
      height: 6px;
    }

    .ant-menu-submenu-popup::-webkit-scrollbar-track,
    .ant-layout-sider::-webkit-scrollbar-track,
    .ant-menu::-webkit-scrollbar-track {
      background: ${dropdownBg};
    }

    .ant-menu-submenu-popup::-webkit-scrollbar-thumb,
    .ant-layout-sider::-webkit-scrollbar-thumb,
    .ant-menu::-webkit-scrollbar-thumb {
      background-color: ${textColor}; /* Scrollbar thumb color */
      border-radius: 4px;
    }



  `;
  }, [themeStyles]);

  useEffect(() => {
    if (!siderRef?.current) return; // check if ref exists

    const observer = new ResizeObserver(() => {
      if (siderRef.current) { // ✅ check inside callback
        setSiderWidth(siderRef.current.offsetWidth);
      }
    });

    observer.observe(siderRef.current);

    return () => observer.disconnect();
  }, [siderRef]);


  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "89vh",
        backgroundColor: themeStyles.siderBg,
        justifyContent: "space-between",
        paddingRight: 0,
        overflowX: "hidden",
        scrollbarWidth: "thin",
        scrollbarColor: "#888 transparent",
      }}
    >
      {/* Top menu */}
      <Menu
        theme={darkMode ? "dark" : "light"}
        mode="inline"
        selectedKeys={[activeKey]}
        openKeys={openKeysState}
        onOpenChange={onOpenChange}
        items={topMenuItems}
        style={{
          flex: 1,
          backgroundColor: themeStyles.siderBg,
          color: themeStyles.textColor,
          border: "none",
        }}
      />

      {/* Bottom (Logout) menu */}
      {/* <Menu
        theme={darkMode ? "dark" : "light"}
        mode="inline"
        selectedKeys={[activeKey]}
        items={footerMenuItems}
        style={{
          backgroundColor: themeStyles.siderBg,
          color: themeStyles.textColor,
          borderTop: "1px solid rgba(255,255,255,0.1)",
          position: "fixed",
          width: "15.2%",
          bottom: 0,
        }}
      /> */}
      <div style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        backgroundColor: themeStyles.siderBg,
        width: siderWidth,
        zIndex: 20,
      }}>
        <Menu
          theme={darkMode ? "dark" : "light"}
          mode="inline"
          items={footerMenuItems}
          style={{
            backgroundColor: themeStyles.siderBg,
            borderTop: "1px solid rgba(255,255,255,0.1)",
          }}
        />
      </div>

    </div>
  );
};

export default SidebarMenu;
